import PropTypes from "prop-types"
import React, { useCallback, useEffect, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "../Common/withRouter"
import { Link, useLocation } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { headerMoreIcon, menuIcons } from "../Common/SvgIcons"
import { useSelector } from "react-redux"
import { uiConsts } from "../../config";
import HomeIcon from '../../assets/images/menu/home.svg';
import { Tooltip } from "reactstrap"


const SidebarContent = props => {
  let menuArray = [
    {
      name: "Home",
      url: "/dashboard",
      icon: menuIcons.home,
      title: 'Home'
    },
    {
      name: "Application",
      url: "/application",
      icon: menuIcons.application,
    },
    {
      name: "Usage",
      url: "/usage",
      icon: menuIcons.usage,
    },
    // {
    //   name: "Modules",
    //   url: "/#",
    //   icon: <i className="uil-folder"></i>,
    //   submenu: [
    //     {
    //       name: "Leads",
    //       url: "/dynamic-module/leads",
    //     },
    //     {
    //       name: "Tasks",
    //       url: "/dynamic-module/tasks",
    //     },
    //     {
    //       name: "Tracks and moniter",
    //       url: "/dynamic-module/track-moniter",
    //     },
    //   ],
    // },
    {
      name: "Settings",
      url: "/#",
      icon: menuIcons.settings,
      submenu: [
        {
          name: "Account settings",
          url: "/settings/account-setting",
        },
        {
          name: "Billing details",
          url: "/settings/billing-details",
        },
        {
          name: "Pricing",
          url: "/settings/pricing",
        },
      ],
    },
  ]
  // const ref = useRef();
  const iconHeight = uiConsts.menuIconHeight // Height of each icon in pixels
  const submenuIconHeight = uiConsts.subMenuIconHeight // Height of submenu icons
  const [maxIconsToShow, setMaxIconsToShow] = useState(
    calculateMaxIconsToShow()
  )
  const [displayedMenu, setDisplayedMenu] = useState(menuArray)
  const sidebarType = useSelector(state => state.Layout.sidebarSizeType)



  const createRenderArray = (arr = [], maxIndex) => {
    if (arr?.length <= 0 || !maxIndex) {
      return []
    }
    let result = arr.map((a, i) => {
      if (i < maxIndex) {
        return a
      } else {
        return {
          ...a,
          hideMenu: true,
        }
      }
    })
    return result
  }
  useEffect(() => {
    function handleResize() {
      // Recalculate the number of icons to show when the screen height changes
      let x = calculateMaxIconsToShow()
      setMaxIconsToShow(x)
      let updatedArr = createRenderArray(menuArray, x)
      setDisplayedMenu(updatedArr)
    }
    handleResize()
    // Add a resize event listener
    window.addEventListener("resize", handleResize)

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      // scrollElement(item);
      return false
    }
    // scrollElement(item);
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    // Considering base path
    const basePath = process.env.REACT_APP_BASE_FOLDER || ""
    const pathName = path.pathname.replace(basePath, "")
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      // Removing base path from each item's pathname before comparing
      const itemPath = items[i].pathname.replace(basePath, "")
      if (pathName === itemPath) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown, sidebarType, props.hoverMenu])

  // useEffect(() => {
  //   ref.current.recalculate();
  // }, []);

  useEffect(() => {
    new MetisMenu("#side-menu")
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  // function scrollElement(item) {
  //   if (item) {
  //     const currentPosition = item.offsetTop;
  //     if (currentPosition > window.innerHeight) {
  //       ref.current.getScrollElement().scrollTop = currentPosition - 300;
  //     }
  //   }
  // }

  const showAllMenu = () => {
    setTimeout(() => {
      var body = document.body
      body.setAttribute("data-sidebar-hover", "true")
      body.setAttribute("data-sidebar-size", "lg")
      props.setHoverMenu(true)
    }, 200)
  }

  useEffect(() => {
    if (!props.hoverMenu) {
      var body = document.body
      let updatedArr = createRenderArray(menuArray, maxIconsToShow)
      setDisplayedMenu(updatedArr)
      body.setAttribute("data-sidebar-hover", "false")
      body.setAttribute("data-sidebar-size", "sm")
    } else {
      setDisplayedMenu(menuArray)
    }
  }, [props.hoverMenu])

  function calculateMaxIconsToShow() {
    const screenHeight = window.innerHeight - 160 // Screen height - (header height, expand button height, menu container pagging)
    let totalHeight = 0
    let iconsToShow = 0

    for (let i = 0; i < menuArray.length; i++) {
      totalHeight += iconHeight // Main menu item height

      if (menuArray[i].submenu && menuArray[i].submenu.length > 0) {
        // If any submenu container overflow then screenheight we are breaking the loop
        let submenuParent = i * iconHeight
        let submenuHeight = menuArray[i].submenu.length * submenuIconHeight + 20 // Plus 20px for submenu container padding
        if (submenuHeight >= screenHeight - submenuParent) {
          break
        }
      }

      if (totalHeight <= screenHeight) {
        iconsToShow = i + 1 // if no issues we are adding an icon to menubar
      } else {
        break
      }
    }

    return iconsToShow
  }

  const renderMenu = displayedMenu
  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {renderMenu &&
              renderMenu.length > 0 &&
              renderMenu.map((menu, index) => {
                let submenuArray = menu.submenu
                let isSubmenu = submenuArray && submenuArray.length > 0
                return (
                  <li
                    key={index}
                    className={`${sidebarType == "sm" && !props.hoverMenu && menu.hideMenu
                      ? "hide-overflow-menu"
                      : ""
                      }`}
                    title={sidebarType == "sm" ? props.t(menu.name) : null}
                  >
                    <Link
                      to={menu.url}
                      className={`${isSubmenu ? "has-arrow " : ""
                        } waves-effect`}
                    >
                      {menu.icon}
                      <span>{props.t(menu.name)}</span>
                    </Link>
                    {
                      isSubmenu && (
                        <ul className="sub-menu">
                          {submenuArray.map((submenu, submenuIndex) => {
                            return (
                              <li key={submenuIndex}>
                                <Link to={submenu.url}>
                                  {props.t(submenu.name)}{" "}
                                </Link>
                              </li>
                            )
                          })}
                        </ul>
                      )
                    }
                  </li >
                )
              })}

            {
              menuArray.length > maxIconsToShow && sidebarType == "sm" && (
                <li onMouseEnter={showAllMenu}>
                  <Link to={"/#"} className={`waves-effect show-more-menu`}>
                    {headerMoreIcon}
                  </Link>
                </li>
              )
            }
          </ul >
        </div >
      </SimpleBar >
    </React.Fragment >
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
